export default {
  title: 'Print',

  labels: {
    logos: 'Images',
    invoiceLogo: 'Invoice logo',
    postalLabelLogo: 'Postal label logo',
    receiptLogo: 'Receipt logo',
    companyLogo: 'Company logo',
    companyName: 'Company name',
    invoiceCompanyName: 'Invoice company name',
    postalLabelCompanyName: 'Postal label company name',
    postalLabelPrintCompanyName: 'Postal label print company name',
    warehouseReceiptCompanyName: 'Warehouse receipt company name',
    treasuryCompanyName: 'Treasury company name',
    lightLogo: 'Light logo',
    stamp: 'Stamp',
    QR: 'QR',
    theme: 'Postal label template',
    companyInfoWithZeroVat: 'If vat is zero, company info show in print invoice'
  },

  themeOptions: {
    theme1: 'A4 Portrait',
    theme2: 'A5 Portrait'
  },

  notifications: {
    wrongValues: 'The entered information is not valid',

    edit: {
      success: 'Print information has been updated successfully',
      error: 'Update Print information has error'
    }
  }
}
